<div class="wrapper">
  <div class="headerWrapper">
    <h2>Модификации</h2>
    <mat-form-field appearance="standard">
      <mat-label>Фильтр</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Фильтр" #input />
    </mat-form-field>
    <div class="carInfoWrapper">
      <h2>{{ carModel?.manufacturer?.description }}</h2>
      <a routerLink="/manufacturer/list" mat-icon-button color="warn">
        <mat-icon>remove</mat-icon>
      </a>
    </div>
    <div class="carInfoWrapper">
      <h2>{{ carModel?.description }}</h2>
      <a [routerLink]="['/model/list', carModel?.manufacturer?.id]" mat-icon-button color="warn">
        <mat-icon>remove</mat-icon>
      </a>
    </div>
    <button mat-mini-fab color="primary" (click)="add()">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <div class="tableWrapper">
    <table mat-table [dataSource]="filteredCarModelTypes">
      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let type">{{ type.id }}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Название</th>
        <td mat-cell *matCellDef="let type" class="select">
          <a [routerLink]="['/modification/profile', type.id, 'items']">
            <div class="descriptionWrapper">
              <span class="descriptionSpan">
                {{ type.description }}
              </span>
              <span class="engineSpan">
                {{ getEngineDescription(type) }}
              </span>
            </div>
          </a>
        </td>
      </ng-container>
      <ng-container matColumnDef="date_from">
        <th mat-header-cell *matHeaderCellDef>Начало производства</th>
        <td mat-cell *matCellDef="let type">
          {{ type.manufacture_date_from.toLocaleDateString() }}
        </td>
      </ng-container>
      <ng-container matColumnDef="horsePower">
        <th mat-header-cell *matHeaderCellDef>Л.С.</th>
        <td mat-cell *matCellDef="let type">
          {{ type.engines[0].horsePower }}
        </td>
      </ng-container>
      <ng-container matColumnDef="capacity">
        <th mat-header-cell *matHeaderCellDef>Обьем см³</th>
        <td mat-cell *matCellDef="let type">
          {{ type.engines[0].capacity }}
        </td>
      </ng-container>
      <ng-container matColumnDef="kW">
        <th mat-header-cell *matHeaderCellDef>кВт.</th>
        <td mat-cell *matCellDef="let type">
          {{ type.engines[0].kW }}
        </td>
      </ng-container>
      <ng-container matColumnDef="fuelType">
        <th mat-header-cell *matHeaderCellDef>Топливо</th>
        <td mat-cell *matCellDef="let type">
          {{ type.engines[0].fuelType }}
        </td>
      </ng-container>
      <ng-container matColumnDef="date_to">
        <th mat-header-cell *matHeaderCellDef>Конец производства</th>
        <td mat-cell *matCellDef="let type">
          {{ getEndDate(type.manufacture_date_to) }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">Не могу ничего найти :(</td>
      </tr>
    </table>
  </div>
</div>
